/* O+ Titanium Core Case — landing page behaviour */
(() => {
  'use strict';
  const root = document.querySelector('.o-titanium-story');
  if (!root || root.dataset.booted) return;
  root.dataset.booted = '1';
  root.classList.add('js');

  /* Set this once the PDP exists. Until then every "View the case" link scrolls to the price section. */
  const PDP_URL = root.dataset.pdpUrl || '';   // section setting "Product page link" (data-pdp-url); blank = no product page yet

  /* s000-s015: the room lights up (s015 = assembled f000). s016 on: the separation. SEP_T gives each separation
     frame's source time (render frame f000 = 0 ... f047 = 47): whole frames, plus in-between frames rendered where
     the parts ease to rest, so the slow end has as many frames as the fast start. */
  const SEP_T = [0.0,1.0,2.0,3.0,4.0,5.0,6.0,7.0,8.0,9.0,10.0,11.0,12.0,13.0,14.0,15.0,16.0,17.0,18.0,19.0,20.0,21.0,22.0,23.0,24.0,25.0,26.0,27.0,28.0,29.0,30.0,31.0,32.0,33.0,34.0,35.0,35.507,36.0,36.508,37.0,37.509,38.0,38.51,39.0,39.511,40.0,40.513,41.0,41.516,42.0,42.35,42.684,43.0,43.355,43.688,44.0,44.276,44.535,44.776,45.0,45.239,45.457,45.656,45.837,46.0,46.167,46.313,46.441,46.552,46.646,46.726,46.792,46.847,46.891,46.951,47.0];
  const LIGHT_END = 15;
  const FRAME_COUNT = LIGHT_END + SEP_T.length;
  const $ = (s, r = root) => r.querySelector(s);
  const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const range = (v, a, b) => clamp((v - a) / (b - a));
  const mqReduce = matchMedia('(prefers-reduced-motion: reduce)');
  let reduce = mqReduce.matches;

  /* ---------- focus rings follow the keyboard: shown once Tab is used, hidden again on a click or tap ----------
     (Escape, arrow keys and focus returning from a closed window don't bring them back) */
  const rootEl = root;
  addEventListener('keydown', e => { if (e.key === 'Tab') rootEl.classList.add('kbd'); }, true);
  addEventListener('pointerdown', () => rootEl.classList.remove('kbd'), true);

  /* ---------- PDP links ---------- */
  if (PDP_URL) $$('[data-pdp]').forEach(a => { a.href = PDP_URL; });
  else $$('#price [data-pdp], .titleblock [data-pdp]').forEach(a => { a.hidden = true; });

  /* ---------- parts content ---------- */
  const PARTS = $$('[data-part-entry]').map(el => ({ id: el.dataset.partEntry, title: el.dataset.title, lead: el.dataset.lead, text: el.dataset.text }));
  PARTS.forEach((p, i) => { p.i = i; });
  const partById = id => PARTS.find(p => p.id === id);
  const VEXT = 'mp4';   // the WebM fallback files are not part of the theme

  /* ---------- stage ---------- */
  const stage = $('#stage');
  const pin = $('.stage-pin', stage);
  const frameEl = $('[data-frame]');
  const plateEl = $('[data-plate]') || pin;
  const canvas = $('[data-canvas]');
  const ctx = canvas.getContext('2d');
  const still = $('[data-still]');
  const hero = $('[data-hero]');
  const heroBtn = $('[data-hero-btn]');
  const heroCopy = $('[data-hero-copy]');
  const caption = $('[data-beat-final]');
  const cue = $('[data-scroll-cue]');
  const hotspotsEl = $('[data-hotspots]');
  const hotspots = $$('.hotspot', hotspotsEl);
  const renderNote = $('[data-render-note]');
  const tour = $('[data-tour]'), tourTrack = $('[data-tour-track]'), tourBlocks = $$('[data-tour-block]');
  hotspots.forEach((h, i) => h.style.setProperty('--i', i));

  const small = () => innerWidth <= 760;
  /* two framings rendered from the same Blender scene: 16:9 for landscape screens, 9:16 for portrait */
  /* each framing comes in two sizes: -hd for screens with the pixels to show it (Retina laptops, modern phones) */
  const FMT_SIZE = { desk: [1920, 1080], 'desk-hd': [2880, 1620], port: [1080, 1920], 'port-hd': [1440, 2560] };
  const pickFmt = () => (innerWidth / innerHeight >= 1 ? 'desk' : 'port');
  let fmt = pickFmt();
  const seqDir = () => {
    const dpr = Math.min(devicePixelRatio || 1, 3);
    return fmt === 'desk' ? (innerWidth * dpr > 2100 ? 'desk-hd' : 'desk') : (innerHeight * dpr > 2000 ? 'port-hd' : 'port');
  };
  // The motion frames only need to match the displayed size; decoding the HD set during playback causes stalls.
  const motionDir = () => fmt;
  const frames = new Array(FRAME_COUNT);
  let loadedDir = null, readyCount = 0;
  /* readyUpTo: the last frame of the unbroken run of loaded frames from s000, so playback can run up to it */
  const failed = new Array(FRAME_COUNT).fill(false);
  let readyUpTo = -1;
  function bumpReady() { while (readyUpTo + 1 < FRAME_COUNT && (frames[readyUpTo + 1] || failed[readyUpTo + 1])) readyUpTo++; }
  function loadFrames() {
    const dir = motionDir();
    if (dir === loadedDir) return;
    loadedDir = dir;
    frames.fill(null); failed.fill(false); lastDrawn = -1; readyCount = 0; readyUpTo = -1;
    for (let i = 0; i < FRAME_COUNT; i++) {
      const img = new Image();
      img.decoding = 'async';
      // decode off the main thread before a frame is ever drawn, so playback never stalls on a decode
      const ready = () => {
        if (loadedDir !== dir || frames[i]) return;
        frames[i] = img; readyCount++; bumpReady();
        if (i === 0 || Math.abs(i - curFrame) < 2) draw(true);
      };
      img.onload = () => { (img.decode ? img.decode() : Promise.resolve()).then(ready, ready); };
      img.onerror = () => { if (loadedDir === dir) { failed[i] = true; readyCount++; bumpReady(); } };
      img.src = root.getAttribute('data-seq-' + dir).replace('s000.webp', `s${String(i).padStart(3, '0')}.webp`);
    }
  }

  let curFrame = 0, lastDrawn = -1;
  /* the frame covers the viewport like object-fit: cover; hotspots live in frame percentages */
  function layoutFrame() {
    const [fw, fh] = FMT_SIZE[motionDir()];
    const vw = plateEl.clientWidth, vh = plateEl.clientHeight;
    const s = Math.max(vw / fw, vh / fh);
    const w = fw * s, h = fh * s;
    // portrait: when the frame is taller than the screen (tablets), keep its top and crop the empty floor instead
    const top = fmt === 'port' && h > vh ? 0 : (vh - h) / 2;
    Object.assign(frameEl.style, { width: `${w}px`, height: `${h}px`, left: `${(vw - w) / 2}px`, top: `${top}px` });
    placeCaption(top, h);
    layoutTour(top, h);
    const dpr = Math.min(devicePixelRatio || 1, 2);
    const cw = Math.round(Math.min(w * dpr, fw)), ch = Math.round(cw * fh / fw);
    if (canvas.width !== cw || canvas.height !== ch) { canvas.width = cw; canvas.height = ch; lastDrawn = -1; }
  }
  /* portrait: the caption sits just under the exploded parts (frame y ~63%) instead of at the foot of the screen */
  const beatsEl = $('[data-beats]'), beatFinalEl = $('[data-beat-final]');
  function placeCaption(top, h) {
    if (!beatsEl || !beatFinalEl) return;
    if (fmt !== 'port') { beatFinalEl.style.top = beatFinalEl.style.bottom = ''; if (renderNote) renderNote.style.top = renderNote.style.bottom = ''; return; }
    const pr = plateEl.getBoundingClientRect(), br = beatsEl.getBoundingClientRect();
    const bh = beatFinalEl.offsetHeight, nh = renderNote ? renderNote.offsetHeight : 0;
    const want = pr.top - br.top + top + h * .63;
    const max = pr.bottom - br.top - bh - nh - 44;
    const y = Math.round(Math.min(want, max));
    beatFinalEl.style.top = `${y}px`; beatFinalEl.style.bottom = 'auto';
    if (renderNote) {
      const nr = renderNote.offsetParent ? renderNote.offsetParent.getBoundingClientRect() : br;
      renderNote.style.top = `${Math.round(br.top - nr.top + y + bh + 18)}px`; renderNote.style.bottom = 'auto';
    }
  }
  function sizeCanvas() { layoutFrame(); }
  function placeHotspots() {
    hotspots.forEach(h => {
      const [x, y, side] = (h.dataset[fmt] || '50,50,right').split(',');
      h.style.setProperty('--x', `${x}%`); h.style.setProperty('--y', `${y}%`);
      h.dataset.side = side;
    });
  }
  /* ---------- tour: while the exploded view holds, text scrolls past it at page speed ----------
     The track moves exactly as far as the page scrolls, so the stage never feels stuck. The stage's
     height is sized to the text: the introduction starts at the middle of its window and the last block
     comes to rest when the stage lets go, then leaves with the page at the same speed. */
  let tourR = 0, tourStart = 0, tourTravel = 0, tourActive = null;
  // a block's reading centre: the middle of its text, not counting the space below it
  const tourMid = b => b.offsetTop + (b.offsetHeight - (parseFloat(getComputedStyle(b).paddingBottom) || 0)) / 2;
  let tourMids = [];
  const TOUR_FOCUS = .45;                                   // the reading line, as a share of the window
  const tourEnd = () => (fmt === 'port' ? .94 : .62);       // where the last block's foot rests at the end
  function layoutTour(top, h) {
    if (!tour) return;
    if (fmt === 'port') {
      // phones: the band between the exploded parts and the render note
      const pinH = pin.clientHeight, plateTop = plateEl.offsetTop, plateBot = plateTop + plateEl.clientHeight;
      const noteH = renderNote ? renderNote.offsetHeight : 0;
      const bottom = pinH - plateBot + noteH + 26;
      let t = Math.round(plateTop + top + h * .6);
      t = Math.min(t, pinH - bottom - 200);
      tour.style.top = `${t}px`; tour.style.bottom = `${bottom}px`;
    } else { tour.style.top = tour.style.bottom = ''; }
    tourR = tour.clientHeight;
    const H = tourTrack.offsetHeight;
    tourMids = tourBlocks.map(tourMid);
    tourStart = tourR * .5 - (tourMids[0] || 0);
    tourTravel = Math.max(0, tourStart + H - tourEnd() * tourR + tourR * .08);
    stage.style.height = `${Math.round(pin.clientHeight + tourTravel)}px`;
    if (gate.armed) placeSnap();   // gate is set up before the first layout (sizeCanvas runs at the end)
  }
  function renderTour(p) {
    if (!tour) return;
    const entrance = 1 - clamp(ex / LA);
    const y = tourStart + tourR * .18 * entrance - Math.max(0, p * tourTravel - tourR * .08);
    tourTrack.style.transform = `translate3d(0, ${y.toFixed(1)}px, 0)`;
    const line = tourR * TOUR_FOCUS;
    let best = null, bd = Infinity;
    tourBlocks.forEach((b, i) => {
      const c = y + tourMids[i], d = Math.abs(c - line);
      if (y + b.offsetTop < tourR && d < bd) { bd = d; best = b; }
    });
    if (best === tourActive) return;
    tourActive = best;
    tourBlocks.forEach(b => b.classList.toggle('is-active', b === best));
    const part = best ? best.dataset.tourBlock : '';
    hotspots.forEach(hs => hs.classList.toggle('is-active', !!part && hs.dataset.part === part));
  }
  // the stage progress at which a block sits on the reading line
  const tourP = b => tourTravel ? clamp((tourStart + tourMid(b) - tourR * TOUR_FOCUS + tourR * .08) / tourTravel) : .4;

  function setHeroSource() {
    const v = seqDir();
    const src = root.getAttribute('data-hero-' + v);
    if (hero.dataset.src === src) return;
    hero.dataset.src = src;
    hero.poster = root.getAttribute('data-poster-' + v);
    hero.src = src;
    still.src = root.getAttribute('data-seq-' + v).replace('s000.webp', v.endsWith('-hd') ? 's062.webp' : 's090.webp');   // final exploded frame: HD sets stay 63 frames (s062), desk/port are 91 (s090)   // the final exploded frame (same image as the last seq5 frame)
  }
  function nearestLoaded(i) {
    for (let d = 0; d < FRAME_COUNT; d++) {
      if (frames[i - d]) return i - d;
      if (frames[i + d]) return i + d;
    }
    return -1;
  }
  /* While the motion is slow (the light-up, the parts settling), blend the two neighbouring frames so the parts
     glide instead of stepping. While it is fast, draw whole frames only, so nothing ghosts. */
  let prevFrame = 0, frameSpeed = 0;
  function draw(force) {
    const f = clamp(curFrame, 0, FRAME_COUNT - 1);
    const i0 = Math.floor(f), i1 = Math.min(i0 + 1, FRAME_COUNT - 1);
    let fr = Math.round((f - i0) * 16) / 16;
    const blend = frameSpeed < .8 && fr > 0 && fr < 1 && frames[i0] && frames[i1];
    if (!blend) {
      const ia = nearestLoaded(Math.round(f));
      if (ia < 0) return;
      if (!force && ia === lastDrawn) return;
      lastDrawn = ia;
      ctx.globalAlpha = 1; ctx.drawImage(frames[ia], 0, 0, canvas.width, canvas.height);
      return;
    }
    const key = i0 + fr / 2;          // distinct from whole-frame keys (integers)
    if (!force && key === lastDrawn) return;
    lastDrawn = key;
    ctx.globalAlpha = 1; ctx.drawImage(frames[i0], 0, 0, canvas.width, canvas.height);
    ctx.globalAlpha = fr; ctx.drawImage(frames[i1], 0, 0, canvas.width, canvas.height);
    ctx.globalAlpha = 1;
  }

  /* The separation is triggered, not scrubbed: a small scroll into the stage plays it through
     on its own, and scrolling back to the very top reassembles it. Visitors never
     have to guess how far to scroll, and the exploded view then holds for the rest of the stage. */
  const T = { trigger: .004, reset: .0005 };
  /* Respond on the first scroll: a quick light-up flows directly into the separation. */
  const LIGHT_MS = 300, SEP_MS = 1500, TOTAL_MS = LIGHT_MS + SEP_MS, BACK_SPEED = 1.9;
  /* One continuous motion, no stop between the two phases: the room lights up while gathering speed (ease-in),
     and the parts leave the case at exactly that speed, then ease to rest (ease-out). The exponent P matches the
     speeds where the phases meet, so there is no pause as the room turns bright. */
  const SEP_END = SEP_T[SEP_T.length - 1];
  const LA = LIGHT_MS / TOTAL_MS;
  /* speeds match at the handover, measured in source time: one light-up frame per whole render frame */
  const P = 2 * LIGHT_END * (1 - LA) / (LA * SEP_END);
  function sepIndex(t) {           // source time -> fractional frame index
    let k = 0; while (k < SEP_T.length - 2 && SEP_T[k + 1] <= t) k++;
    return LIGHT_END + k + clamp((t - SEP_T[k]) / (SEP_T[k + 1] - SEP_T[k]));
  }
  function frameAt(u) {
    if (u < LA) return LIGHT_END * (u / LA) * (u / LA);
    return sepIndex(SEP_END * (1 - Math.pow(1 - clamp((u - LA) / (1 - LA)), P)));
  }
  let heroState = 'idle'; // idle | playing | paused | done | blocked
  let progress = 0;
  let ex = 0, exTarget = 0, exFrom = 0, exStart = 0, exRaf = 0;

  function stageProgress() {
    const r = stage.getBoundingClientRect();
    const total = r.height - pin.clientHeight;
    return total > 0 ? clamp(-r.top / total) : 0;
  }

  function setExplode(t, instant) {
    if (t === exTarget && !instant) return;
    exTarget = t;
    stage.classList.toggle('is-exploded', t === 1);
    // on the way back to the hero the text column leaves first, so it never overlaps the hero copy
    stage.classList.toggle('is-reassembling', t === 0 && !instant);
    if (t === 1) {
      if (hero.classList.contains('is-on')) hero.classList.add('is-quick');
      if (heroState === 'playing') { hero.pause(); heroState = 'done'; }
      hero.classList.remove('is-on');
      setHeroBtn();
    }
    if (instant || reduce) { ex = t; renderEx(); return; }
    // The render starts beneath the fading film immediately, so scrolling has visible feedback.
    exFrom = ex; exStart = performance.now();
    if (!exRaf) exRaf = requestAnimationFrame(tickEx);
  }
  function tickEx(now) {
    exRaf = 0;
    const dur = TOTAL_MS / (exTarget ? 1 : BACK_SPEED) * Math.abs(exTarget - exFrom);
    let t = dur > 0 ? clamp((now - exStart) / dur) : 1;
    // Never play ahead of the frames that have arrived; hold only at the first missing frame, not the whole light-up.
    if (exTarget === 1 && readyUpTo < FRAME_COUNT - 1 && frameAt(lerp(exFrom, exTarget, t)) > readyUpTo) {
      let lo = exFrom, hi = 1;
      for (let k = 0; k < 20; k++) { const m = (lo + hi) / 2; if (frameAt(m) > readyUpTo) hi = m; else lo = m; }
      t = clamp((lo - exFrom) / (exTarget - exFrom));
      exStart = now - t * dur;
    }
    ex = lerp(exFrom, exTarget, t);
    renderEx();
    if (t < 1) exRaf = requestAnimationFrame(tickEx);
  }
  function renderEx() {
    curFrame = frameAt(ex);
    frameSpeed = Math.abs(curFrame - prevFrame); prevFrame = curFrame;
    draw();
    stage.classList.toggle('is-lit', curFrame > LIGHT_END * .5);
    if (tour) tour.style.opacity = clamp((ex - LA * .35) / (LA * .9)).toFixed(3);
    renderTour(tourPos(progress));
    const settled = exTarget === 1 && ex > .995;
    toggleHotspots(settled);
    if (caption) caption.classList.toggle('is-on', settled);
    renderNote.classList.toggle('is-on', curFrame > sepIndex(1));
  }

  function update() {
    progress = stageProgress();
    const p = progress;
    if (p < T.reset) armGate();
    renderTour(tourPos(p));
    if (p > T.trigger) setExplode(1);
    else if (p < T.reset) setExplode(0);
    heroBtn.hidden = exTarget === 1;
  }

  let hotOn = false;
  function toggleHotspots(on) {
    if (on === hotOn) return;
    hotOn = on;
    hotspotsEl.classList.toggle('is-on', on);
    hotspots.forEach((h, i) => { h.tabIndex = on || i === 0 ? 0 : -1; });
  }

  // keyboard users reaching a hidden hotspot get brought to the exploded view
  hotspots.forEach(h => h.addEventListener('focus', () => {
    if (!hotOn) { scrollStageTo(.4, true); setExplode(1, true); }
  }));
  cue.addEventListener('click', () => scrollStageTo(tourBlocks.length ? tourP(tourBlocks[0]) : .4));
  // keyboard: tabbing onto a block's button brings that block onto the reading line
  tourBlocks.forEach(b => { const btn = $('button', b); btn && btn.addEventListener('focus', () => {
    if (b !== tourActive) { setExplode(1, true); scrollStageTo(tourP(b), true); }
  }); });
  /* First scroll after the hero: however hard the flick, the page stops where the first block of text sits
     on the reading line. The wall only stops the gesture that hit it (and its momentum): a new swipe, a
     fresh wheel movement or a key press goes straight on. A scroll that comes to rest short of it glides on
     to the same point. The wall is back whenever the visitor returns to the top of the stage, and links and
     keyboard jumps open it. Downward input waits for the landing; upward input always lets the visitor return to the hero. */
  const gate = { armed: false, holding: false, idle: 0, anim: 0, touching: false, touchY: 0, live: false,
    lastWheel: 0, hist: [], peak: 0, decayed: false };
  const SNAP_MS = 1100;
  const easeInOut = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  const gateP = () => tourP(tourBlocks[0]);
  function gateY() {
    const r = stage.getBoundingClientRect();
    return Math.round(scrollY + r.top + gateP() * (r.height - pin.clientHeight));
  }
  const tourPos = p => gate.armed ? Math.min(p, gateP()) : p;   // the text never shows past the wall
  const atWall = () => scrollY >= gateY() - 2;
  /* Touch screens: the browser itself stops the fling. While the wall is up the page snaps (natively, on the
     compositor) between the hero and the wall, so nothing waits on script or fights the momentum, however
     busy the explosion keeps the page. The snap is switched off as soon as the visitor lands or touches again. */
  const COARSE = matchMedia('(pointer: coarse)').matches;
  const snapMarks = [0, 1].map(() => {
    const m = document.createElement('div');
    m.setAttribute('aria-hidden', 'true');
    m.style.cssText = 'position:absolute;left:0;width:1px;height:1px;pointer-events:none;visibility:hidden;scroll-snap-align:start;scroll-snap-stop:always';
    return m;
  });
  function placeSnap() {
    if (!COARSE || !tourBlocks.length) return;
    const pad = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    const stageTop = scrollY + stage.getBoundingClientRect().top;
    snapMarks[0].style.top = `${Math.round(pad - stageTop)}px`;                 // page top
    snapMarks[1].style.top = `${Math.round(gateY() + pad - stageTop)}px`;       // the wall
    snapMarks.forEach(m => { if (!m.parentNode) stage.appendChild(m); });
  }
  function setSnap(on) {
    if (!COARSE) return;
    if (on) placeSnap();
    document.documentElement.style.scrollSnapType = on ? 'y mandatory' : '';
  }
  function armGate() {
    gate.holding = gate.decayed = false; gate.peak = 0;   // back on the hero: nothing is held here
    if (gate.armed || !tourBlocks.length) return;
    gate.armed = true;
    setSnap(true);
    if (!gate.live && !COARSE) {    // wheel input is only held back while the wall is up
      gate.live = true;
      addEventListener('wheel', gateWheel, { passive: false });
    }
  }
  function openGate() {
    gate.armed = gate.holding = gate.decayed = false; gate.peak = 0; clearTimeout(gate.idle);
    setSnap(false);
    if (gate.live) {
      gate.live = false;
      removeEventListener('wheel', gateWheel, { passive: false });
    }
  }
  function cancelGlide() { if (gate.anim) { cancelAnimationFrame(gate.anim); gate.anim = 0; } }
  function gateSoon() {
    clearTimeout(gate.idle);
    if (gate.armed && !gate.touching && !gate.anim) gate.idle = setTimeout(gateRest, 150);   // never under a resting finger
  }
  function holdAt() {
    const to = gateY();
    // Land before marking the gesture as held; a smooth scroll can still be short of the stop.
    if (Math.abs(scrollY - to) > 1) scrollTo({ top: to, behavior: 'instant' });
    gate.holding = true; gateSoon();
  }
  function gateRest() {             // the entering gesture (and its momentum) has ended
    if (!gate.armed || gate.touching) return;
    if (stageProgress() <= T.trigger) { gate.holding = false; return; }   // still on the hero: keep the wall up
    const to = gateY(), from = scrollY;
    if (COARSE) { openGate(); return; } // touch uses the native snap
    if (gate.holding && atWall()) { openGate(); return; }
    if (from >= to - 2 || reduce) { holdAt(); return; }
    const t0 = performance.now(), dur = Math.min(SNAP_MS, 500 + (to - from) * .5);
    const step = now => {
      const k = clamp((now - t0) / dur);
      scrollTo({ top: from + (to - from) * easeInOut(k), behavior: 'instant' });
      gate.anim = k < 1 ? requestAnimationFrame(step) : 0;
      if (k === 1) holdAt();
    };
    gate.anim = requestAnimationFrame(step);
  }
  function gateWheel(e) {
    if (!gate.armed || e.ctrlKey) return;
    const dy = e.deltaY * (e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? innerHeight : 1);
    if (dy < 0) cancelGlide();
    // the input's own timestamp, so a busy main thread (frames decoding) can't fake a pause
    const now = e.timeStamp || performance.now(), gap = now - gate.lastWheel, a = Math.abs(dy), h = gate.hist;
    gate.lastWheel = now;
    if (gap > 160) { h.length = 0; gate.peak = 0; gate.decayed = false; }
    // once the flick's momentum has started to fade, any rise means fingers are moving again
    if (gate.holding) { gate.peak = Math.max(gate.peak, a); if (a < gate.peak * .6) gate.decayed = true; }
    const rising = gate.decayed && h.length >= 3 && a > 1.25 * (h[h.length - 1] + h[h.length - 2] + h[h.length - 3]) / 3 + 3;
    h.push(a); if (h.length > 8) h.shift();
    // Still track the gesture while gliding, so its tail cannot masquerade as a fresh swipe on arrival.
    if (gate.anim && dy > 0) { e.preventDefault(); return; }
    // after landing, the wall lets go of any new movement at once: a pause or a new push; the momentum's last trickle stays stopped
    if (gate.holding && dy > 0 && (gap > 160 || rising)) { openGate(); return; }
    if (dy > 0 && (scrollY + dy > gateY() || (gate.holding && atWall()))) { e.preventDefault(); holdAt(); }
    else gateSoon();
  }
  // Downward input cannot interrupt the initial landing; upward input can always return to the hero.
  addEventListener('pointerdown', cancelGlide, { passive: true });
  addEventListener('touchstart', () => {
    cancelGlide();
    // a new touch once the first swipe has carried the page into the stage goes straight on
    if (gate.holding || (COARSE && gate.armed && stageProgress() > T.trigger)) openGate();
    gate.touching = true; clearTimeout(gate.idle);
  }, { passive: true });
  ['touchend', 'touchcancel'].forEach(ev => addEventListener(ev, e => {
    if (e.touches && e.touches.length) return;
    gate.touching = false; gateSoon();
  }, { passive: true }));
  addEventListener('keydown', e => {
    cancelGlide();
    if (!gate.armed || !gate.holding || e.target.closest('input, textarea, select, [contenteditable]')) return;
    if (!e.repeat) { openGate(); return; }      // a fresh key press goes on; a held-down key stops at the wall
    if (['ArrowDown', 'PageDown', ' ', 'Spacebar', 'End'].includes(e.key) && atWall()) { e.preventDefault(); gateSoon(); }
  });
  addEventListener('scroll', () => {
    if (!gate.armed || gate.anim) return;
    if (!COARSE && scrollY > gateY() + 1) holdAt(); else gateSoon();
  }, { passive: true });
  // in-page links go where they point
  document.addEventListener('click', e => { if (e.target.closest && e.target.closest('a[href^="#"]')) openGate(); }, true);

  function scrollStageTo(p, instant) {
    openGate();
    const r = stage.getBoundingClientRect();
    const top = scrollY + r.top + p * (r.height - pin.clientHeight);
    scrollTo({ top, behavior: reduce || instant ? 'auto' : 'smooth' });
  }

  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { ticking = false; update(); });
  }

  /* ---------- hero film ---------- */
  function setHeroBtn() {
    const icon = heroState === 'playing' ? 'pause' : heroState === 'done' ? 'replay' : 'play';
    const label = heroState === 'playing' ? 'Pause film' : heroState === 'done' ? 'Replay film' : 'Play film';
    heroBtn.setAttribute('aria-label', label);
    $('use', heroBtn).setAttribute('href', `#o-ti-i-${icon}`);
    heroBtn.hidden = exTarget === 1;
    stage.classList.toggle('film-running', heroState === 'playing');
  }
  function playHero(fromStart) {
    if (fromStart) try { hero.currentTime = 0; } catch (_) {}
    hero.classList.remove('is-quick');
    hero.classList.add('is-on');
    const pr = hero.play();
    heroState = 'playing'; setHeroBtn();
    if (pr && pr.catch) pr.catch(() => { heroState = 'blocked'; hero.classList.remove('is-on'); setHeroBtn(); });
  }
  hero.addEventListener('error', () => { heroState = 'blocked'; hero.classList.remove('is-on'); setHeroBtn(); });
  hero.addEventListener('ended', () => {
    heroState = 'done';
    hero.classList.remove('is-on'); // dissolves into the matched render frame
    setHeroBtn();
  });
  heroBtn.addEventListener('click', () => {
    if (heroState === 'playing') { hero.pause(); heroState = 'paused'; setHeroBtn(); }
    else if (heroState === 'paused') { playHero(false); }
    else { if (exTarget === 1) { scrollStageTo(0, true); setExplode(0, true); } playHero(true); }
  });

  /* ---------- looping section films: play in view, pause offscreen ---------- */
  const loops = $$('video[data-loop]');
  const userPaused = new WeakSet();
  function setLoopBtn(v) {
    const btn = v.parentElement.querySelector('[data-loop-btn]');
    if (!btn) return;
    const playing = !v.paused;
    btn.setAttribute('aria-label', playing ? 'Pause film' : 'Play film');
    $('use', btn).setAttribute('href', playing ? '#o-ti-i-pause' : '#o-ti-i-play');
  }
  const io = new IntersectionObserver(entries => {
    entries.forEach(en => {
      const v = en.target;
      if (en.isIntersecting && !reduce && !userPaused.has(v) && !document.hidden) {
        v.preload = 'auto';
        const pr = v.play(); if (pr && pr.catch) pr.catch(() => setLoopBtn(v));
      } else if (!en.isIntersecting) v.pause();
    });
  }, { threshold: .35 });
  loops.forEach(v => {
    io.observe(v);
    v.addEventListener('play', () => setLoopBtn(v));
    v.addEventListener('pause', () => setLoopBtn(v));
    setLoopBtn(v);
    const btn = v.parentElement.querySelector('[data-loop-btn]');
    btn && btn.addEventListener('click', () => {
      if (v.paused) { userPaused.delete(v); v.play(); } else { userPaused.add(v); v.pause(); }
    });
  });

  /* hero pauses when the stage leaves view */
  new IntersectionObserver(([en]) => {
    if (!en.isIntersecting && heroState === 'playing') { hero.pause(); heroState = 'paused'; setHeroBtn(); }
  }).observe(stage);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      loops.forEach(v => v.pause());
      if (heroState === 'playing') { hero.pause(); heroState = 'paused'; setHeroBtn(); }
      if (pdVideo) pdVideo.pause();
    }
  });

  /* traced outline: the dots draw round the frame one by one, hold, clear in the same order,
     and loop for as long as the photo is on screen (restarting from the top each time it comes into view) */
  const trace = $('[data-trace]');
  if (trace) {
    const dots = $$('circle', trace), N = dots.length, R = 3.4;
    const SPREAD = 2.4, POP = .22, HOLD = 5.2, OUT = .28, CYCLE = 8.4;
    let t0 = 0, raf = 0, on = false;
    const showAll = () => dots.forEach(c => { c.style.opacity = 1; c.setAttribute('r', R); });
    const frame = now => {
      const t = ((now - t0) / 1000) % CYCLE;
      for (let i = 0; i < N; i++) {
        const o = i / (N - 1) * SPREAD;
        let a = 0, k = .2;
        if (t >= o && t < o + HOLD + OUT) {
          const u = t - o;
          if (u < POP) { const q = u / POP; a = q; k = .2 + q * 1.1; }          // pop in, slight overshoot
          else if (u < POP + .12) { a = 1; k = 1.3 - (u - POP) / .12 * .3; }   // settle
          else if (u < HOLD) { a = 1; k = 1; }
          else { const q = (u - HOLD) / OUT; a = 1 - q; k = 1 - q * .4; }     // clear
        }
        const c = dots[i];
        c.style.opacity = a.toFixed(3);
        c.setAttribute('r', (R * k).toFixed(2));
      }
      raf = on ? requestAnimationFrame(frame) : 0;
    };
    new IntersectionObserver(([en]) => {
      if (reduce) { showAll(); return; }
      if (en.isIntersecting && !on) { on = true; t0 = performance.now(); raf = requestAnimationFrame(frame); }
      else if (!en.isIntersecting && on) { on = false; cancelAnimationFrame(raf); raf = 0; }
    }, { threshold: .15 }).observe(trace);
    if (reduce) showAll();
  }

  /* tape measure draws once in view */
  const tape = $('.tape');
  if (tape) new IntersectionObserver(([en], ob) => { if (en.isIntersecting) { tape.classList.add('is-in'); ob.disconnect(); } }, { threshold: .5 }).observe(tape);

  /* ---------- interactive titanium core (loads as the section approaches) ---------- */
  const core3d = $('[data-core3d]');
  if (core3d) {
    const host = $('[data-core3d-stage]', core3d);
    const hint = $('[data-core3d-hint]', core3d);
    const hintText = $('[data-core3d-hint-text]', core3d);
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) hintText.textContent = root.dataset.hintFine || 'Move your cursor, or drag, to turn the core';
    let started = false;
    const start = () => {
      if (started) return; started = true;
      import(root.dataset.coreJs).then(({ mountCore }) => {
        const api = mountCore(host, {
          src: root.dataset.modelSrc,
          zone: core3d,
          fill: innerWidth < 900 ? .84 : .9,
          reduce: () => reduce,
          label: 'The titanium core, a curved sheet with two long cutouts. Drag, or use the arrow keys, to turn it.',
          onReady: () => core3d.classList.add('is-live'),
          onInteract: () => hint.classList.add('is-used'),
          onError: () => core3d.classList.remove('is-live')
        });
        if (!api) core3d.classList.add('no-webgl');
      }).catch(() => core3d.classList.add('no-webgl'));
    };
    new IntersectionObserver(([en], ob) => { if (en.isIntersecting) { start(); ob.disconnect(); } }, { rootMargin: '100% 0px' }).observe(core3d);
  }

  /* ---------- part dialog ---------- */
  const dlg = $('[data-dialog]');
  const panel = $('[data-panel]', dlg);
  const pdVideo = $('[data-pd-video]', dlg);
  const pdPlay = $('[data-pd-play]', dlg);
  const MOBILE_PD = matchMedia('(max-width: 760px)'), SQUARE_CUT = new Set(['core', 'lining', 'signature']);
  let current = null, opener = null, closing = false;

  function fillPart(p) {
    current = p;
    $('[data-pd-title]', dlg).textContent = p.title;
    $('[data-pd-lead]', dlg).textContent = p.lead;
    $('[data-pd-text]', dlg).replaceChildren(...p.text.split('\n\n').map(text => {
      const paragraph = document.createElement('p');
      paragraph.textContent = text;
      return paragraph;
    }));
    $('[data-pd-count]', dlg).textContent = (root.dataset.countLabel || '{n} of {total}, inside out').replace('{n}', p.i + 1).replace('{total}', PARTS.length);
    const prev = PARTS[(p.i + PARTS.length - 1) % PARTS.length], next = PARTS[(p.i + 1) % PARTS.length];
    $('[data-pd-prev-label]', dlg).textContent = prev.title;
    $('[data-pd-next-label]', dlg).textContent = next.title;
    const base = p.id === 'stitching' ? 'part' : 'detail';
    // on phones the panel is square: core and lining use square cuts framed so the part never leaves the picture
    const sq = MOBILE_PD.matches && SQUARE_CUT.has(p.id) ? '-m' : '';
    pdVideo.poster = root.getAttribute(`data-img-${base}-${p.id}${sq}`);
    pdVideo.src = root.getAttribute(`data-video-${base}-${p.id}${sq}`);
    pdVideo.setAttribute('aria-label', `Rendered film of the ${p.title.toLowerCase()}.`);
    hotspots.forEach(h => h.setAttribute('aria-expanded', String(h.dataset.part === p.id)));
    if (!reduce) { const pr = pdVideo.play(); if (pr && pr.catch) pr.catch(() => setPdBtn()); }
    setPdBtn();
  }
  /* part films play once and hold their last frame; the button then offers a replay */
  function setPdBtn() {
    const playing = !pdVideo.paused, ended = pdVideo.ended;
    pdPlay.setAttribute('aria-label', playing ? 'Pause film' : ended ? 'Replay film' : 'Play film');
    $('use', pdPlay).setAttribute('href', playing ? '#o-ti-i-pause' : ended ? '#o-ti-i-replay' : '#o-ti-i-play');
  }
  pdVideo.addEventListener('play', setPdBtn);
  pdVideo.addEventListener('pause', setPdBtn);
  pdVideo.addEventListener('ended', setPdBtn);
  pdPlay.addEventListener('click', () => {
    if (pdVideo.ended) { pdVideo.currentTime = 0; pdVideo.play(); }
    else if (pdVideo.paused) pdVideo.play();
    else pdVideo.pause();
  });

  function openPart(id, trigger) {
    const p = partById(id); if (!p) return;
    opener = trigger || null;
    const scrollKeep = scrollY;
    if (trigger && !small()) {
      const r = trigger.getBoundingClientRect();
      const pw = Math.min(1040, innerWidth - 48), ph = Math.min(820, innerHeight - 48);
      const px = (innerWidth - pw) / 2, py = (innerHeight - ph) / 2;
      panel.style.setProperty('--ox', `${clamp(r.left + r.width / 2 - px, 0, pw)}px`);
      panel.style.setProperty('--oy', `${clamp(r.top + r.height / 2 - py, 0, ph)}px`);
    }
    fillPart(p);
    document.documentElement.style.overflow = 'hidden';
    dlg.showModal();
    scrollTo(0, scrollKeep);
    requestAnimationFrame(() => requestAnimationFrame(() => dlg.classList.add('is-open')));
    // focus the panel itself, not the close button, so no focus ring appears on open
    panel.focus({ preventScroll: true });
  }
  function closePart() {
    if (!dlg.open || closing) return;
    closing = true;
    dlg.classList.remove('is-open');
    pdVideo.pause();
    const done = () => {
      closing = false;
      dlg.close();
      document.documentElement.style.overflow = '';
      hotspots.forEach(h => h.setAttribute('aria-expanded', 'false'));
      if (opener) opener.focus({ preventScroll: true });
      pdVideo.removeAttribute('src'); pdVideo.load();
    };
    reduce ? done() : setTimeout(done, 320);
  }
  dlg.addEventListener('cancel', e => { e.preventDefault(); closePart(); });
  dlg.addEventListener('click', e => { if (e.target === dlg) closePart(); });
  $('[data-pd-close]', dlg).addEventListener('click', closePart);
  $('[data-pd-prev]', dlg).addEventListener('click', () => fillPart(PARTS[(current.i + PARTS.length - 1) % PARTS.length]));
  $('[data-pd-next]', dlg).addEventListener('click', () => fillPart(PARTS[(current.i + 1) % PARTS.length]));
  dlg.addEventListener('keydown', e => {
    if (e.target.closest('button') && (e.key === 'Enter' || e.key === ' ')) return;
    if (e.key === 'ArrowRight') fillPart(PARTS[(current.i + 1) % PARTS.length]);
    if (e.key === 'ArrowLeft') fillPart(PARTS[(current.i + PARTS.length - 1) % PARTS.length]);
  });
  $$('[data-part]').forEach(b => b.addEventListener('click', () => openPart(b.dataset.part, b)));

  /* ---------- questions: answers slide open and closed ---------- */
  $$('.faq details').forEach(d => {
    const sum = $('summary', d), body = $('p', d);
    if (!sum || !body) return;
    let anim = null;
    const done = () => { body.style.overflow = ''; anim = null; };
    sum.addEventListener('click', e => {
      if (reduce || !body.animate) return;
      e.preventDefault();
      if (anim) { anim.cancel(); anim = null; }
      const closing = d.open && !d.classList.contains('is-closing');
      body.style.overflow = 'hidden';
      if (!closing) {
        d.classList.remove('is-closing'); d.open = true;
        const h = body.offsetHeight, mb = getComputedStyle(body).marginBottom;
        anim = body.animate([
          { height: '0px', marginBottom: '0px', opacity: 0, transform: 'translateY(-8px)' },
          { height: `${h}px`, marginBottom: mb, opacity: 1, transform: 'none' }
        ], { duration: 460, easing: 'cubic-bezier(.2, .75, .2, 1)' });
        anim.onfinish = done;
      } else {
        const h = body.offsetHeight, mb = getComputedStyle(body).marginBottom;
        d.classList.add('is-closing');
        anim = body.animate([
          { height: `${h}px`, marginBottom: mb, opacity: 1 },
          { height: '0px', marginBottom: '0px', opacity: 0 }
        ], { duration: 320, easing: 'cubic-bezier(.4, 0, .2, 1)' });
        anim.onfinish = () => { d.open = false; d.classList.remove('is-closing'); done(); };
      }
    });
  });

  /* ---------- boot ---------- */
  function onResize() {
    const nf = pickFmt();
    if (nf !== fmt) { fmt = nf; pin.dataset.fmt = fmt; placeHotspots(); setHeroSource(); if (heroState === 'playing') { hero.pause(); heroState = 'done'; } hero.classList.remove('is-on'); setHeroBtn(); }
    sizeCanvas(); loadFrames(); draw(true); update();
  }
  addEventListener('resize', onResize, { passive: true });
  addEventListener('scroll', () => { onScroll(); }, { passive: true });
  mqReduce.addEventListener && mqReduce.addEventListener('change', e => { reduce = e.matches; update(); });

  pin.dataset.fmt = fmt;
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { sizeCanvas(); update(); });
  placeHotspots();
  setHeroSource();
  sizeCanvas();
  loadFrames();
  if (stageProgress() > T.trigger) setExplode(1, true);
  update();
  // until the view is exploded, only the first hotspot is in the tab order; focusing it brings the view there
  if (!hotOn) hotspots.forEach((h, i) => { h.tabIndex = i === 0 ? 0 : -1; });

  if (reduce) {
    heroState = 'idle';
    hero.classList.remove('is-on');
    setHeroBtn();
  } else if (exTarget === 0) {
    playHero(true);
  } else {
    heroState = 'done'; setHeroBtn();
  }
})();

/* ---- site header: transparent over the stage, solid once the stage has scrolled past ---- */
(() => {
  'use strict';
  const root = document.querySelector('.o-titanium-story');
  const stage = root && root.querySelector('.stage');
  const hdr = document.querySelector('.shopify-section--header');
  if (!stage || !hdr) return;
  const html = document.documentElement;
  let raf = 0;
  const update = () => {
    raf = 0;
    const bar = hdr.querySelector('.header');
    const h = bar ? bar.offsetHeight : hdr.offsetHeight;
    html.classList.toggle('ti-hdr-solid', stage.getBoundingClientRect().bottom <= h + 1);
  };
  const queue = () => { if (!raf) raf = requestAnimationFrame(update); };
  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', queue);
  update();
})();
